import React, { useEffect, useState } from "react";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faUsers,
  faHandsHelping,
  faBriefcase,
  faFileAlt,
  faSignOutAlt,
  faGears,
  faBuilding,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";
import "./Navbar.css";
import { MdCardMembership } from "react-icons/md";
import url from "../../function/url";
import Cookies from "js-cookie";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
function Navbar() {
  const ID = Cookies.get("log_id");
  const user = Cookies.get("User");
  const navigate = useNavigate();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isprofileDropdown, setProfiledropdown] = useState(false);
  const [isUnemployeddown, setUnemployeddrop] = useState(false);
  const [isProductsdown, setProductsdrop] = useState(false);
  const [isHighlightdown, setHighlightdrop] = useState(false);
  const [isPremiumMembershipManager, setPremiumMembershipManager] =
    useState(false);
  const [ismembership, setMembership] = useState(false);

  const toggleMembership = () => {
    setMembership(!ismembership);
  };

  const togglePremiumMembershipManager = () => {
    setPremiumMembershipManager(!isPremiumMembershipManager);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleProfile = () => {
    setProfiledropdown(!isprofileDropdown);
  };
  const toggleUnemployed = () => {
    setUnemployeddrop(!isUnemployeddown);
  };
  const toggleproducts = () => {
    setProductsdrop(!isProductsdown);
  };

  const toggleHighlight = () => {
    setHighlightdrop(!isHighlightdown);
  };

  const [username, setUsername] = useState("");
  const [image, setImage] = useState("");
  function LoginDetails() {
    axios
      .get(`${url.path}/login_details/${ID}/`)
      .then((res) => {
        if (res.data.status) {
          setUsername(res.data.name);
          const img = res.data.image;
          var imag = null;
          if (img) {
            imag = `${url.path}/${img}`;
          }
          setImage(imag);
        }
      })
      .catch((err) => {
        console.log("HOME ERROR==", err);
      });
  }
  useEffect(() => {
    LoginDetails();
  }, []);

  function Logout() {
    Cookies.remove("User");
    Cookies.remove("log_id");
    navigate("/");
  }
  function bothwork() {
    closeMobileMenu();
    Logout();
  }
  return (
    <div className="dashboard-container">
      <div className="topbar">
        <div className="topbar-logo">JOB MARKET</div>
      </div>

      {user == "Telecaller" ? (
        <div className="dashboard-content">
          <div className="sidebar">
            <div className="sidebar-profile">
              {image ? (
                <img src={image} className="user-img" />
              ) : (
                <img src="user8.jpeg" alt="Profile" />
              )}
              <p>{username}</p>
              <span>✅ Verified</span>
            </div>
            <nav>
              <ul>
                <li className={`dropdown ${isprofileDropdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleProfile();
                    }}
                    className="dropdown-toggles"
                  >
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isprofileDropdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/profile">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="/add_profile_details">Add</NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Employees
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isDropdownOpen && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="">Attendence</NavLink>
                      </li>
                      <li>
                        <NavLink to="/telecaller-assigned-requests">
                          Job/stream change Requests
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/telecaller-assigned-blacklist-requests">
                          Blacklist Requests
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li className={`dropdown ${ismembership ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleMembership();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Membership Request
                    {ismembership ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {ismembership && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/membershipCompany">Company</NavLink>
                      </li>
                      <li>
                        <NavLink to="/membershipEmployee">Employee</NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li className={`dropdown ${isProductsdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleproducts();
                    }}
                  >
                    <FontAwesomeIcon icon={faGears} className="icon" /> Products
                    {isProductsdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isProductsdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/new_products_telecaller">New</NavLink>
                      </li>
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="/ads_request_telecaller">
                          Ads Request
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li className={`dropdown ${isHighlightdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleHighlight();
                    }}
                  >
                    <FontAwesomeIcon icon={faBuilding} className="icon" />{" "}
                    Highlight
                    {isHighlightdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isHighlightdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/company_highlight_request_telecaller">
                          Company
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/product_highligth_request_telecaller">
                          Product
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <NavLink
                    to="/telecallersuggestion"
                    className="flex items-center"
                  >
                    <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                    <span className="whitespace-nowrap">
                      Suggestion and Counseling
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="">
                    <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job
                    Applicants
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/target_audience_page_telecaller">
                    <FontAwesomeIcon icon={faBullseye} className="icon" />{" "}
                    Target Audience
                  </NavLink>
                </li>
                <li>
                  <a onClick={Logout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div className="mobile-header">
            <FaBars className="menu-icon" onClick={toggleMobileMenu} />
          </div>

          {isMobileMenuOpen && (
            <div className="sidebar mobile-sidebar">
              <button className="close-menu-btn" onClick={closeMobileMenu}>
                <FaTimes className="close-icon" />
              </button>
              <nav>
                <ul>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleProfile}
                    >
                      <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                      {isprofileDropdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isprofileDropdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/add_profile_details"
                            onClick={closeMobileMenu}
                          >
                            Add
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleDropdown}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Employees
                      {isDropdownOpen ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            Attendence
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/telecaller-assigned-requests">
                            Job/stream change Requests
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/telecaller-assigned-blacklist-requests">
                            Blacklist Requests
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleMembership}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Membership Request
                      {ismembership ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {ismembership && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/membershipCompany"
                            onClick={closeMobileMenu}
                          >
                            Company
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/membershipEmployee"
                            onClick={closeMobileMenu}
                          >
                            Employee
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleproducts}
                    >
                      <FontAwesomeIcon icon={faGears} className="icon" />{" "}
                      Products
                      {isProductsdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isProductsdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/new_products_telecaller"
                            onClick={closeMobileMenu}
                          >
                            New
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/ads_request_telecaller"
                            onClick={closeMobileMenu}
                          >
                            Ads Request
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleHighlight}
                    >
                      <FontAwesomeIcon icon={faBuilding} className="icon" />{" "}
                      Highlight
                      {isHighlightdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isHighlightdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/company_highlight_request_telecaller"
                            onClick={closeMobileMenu}
                          >
                            Company
                          </NavLink>
                        </li>

                        <li>
                          <NavLink
                            to="/product_highligth_request_telecaller"
                            onClick={closeMobileMenu}
                          >
                            Product
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <NavLink
                      to="/telecallersuggestion"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                      <span className="whitespace-nowrap">
                        Suggestion and Counseling
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="" onClick={closeMobileMenu}>
                      <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job
                      Applicants
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/target_audience_page_telecaller"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faBullseye} className="icon" />{" "}
                      Target Audience
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="" onClick={bothwork}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                      Logout
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      ) : user == "Socialworker" ? (
        <div className="dashboard-content">
          <div className="sidebar">
            <div className="sidebar-profile">
              {image ? (
                <img src={image} className="user-img" />
              ) : (
                <img src="user8.jpeg" alt="Profile" />
              )}
              <p>{username}</p>
              <span>✅ Verified</span>
            </div>
            <nav>
              <ul>
                {/* Profile Section */}
                <li className={`dropdown ${isprofileDropdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleProfile();
                    }}
                    className="dropdown-toggles"
                  >
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isprofileDropdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/profile">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="/add_profile_details">Add</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Employees Section */}
                <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Employees
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isDropdownOpen && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="">Attendance</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Unemployed Section */}
                <li className={`dropdown ${isUnemployeddown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleUnemployed();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Unemployed
                    {isUnemployeddown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isUnemployeddown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/new_unemployed">New</NavLink>
                      </li>
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Suggestion and Counseling Section */}
                <li>
                  <NavLink
                    to="/socialworkersuggestion"
                    className="flex items-center"
                  >
                    <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                    <span className="whitespace-nowrap">
                      Suggestion and Counseling
                    </span>
                  </NavLink>
                </li>

                {/* Logout Section */}
                <li>
                  <a onClick={Logout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Mobile Header */}
          <div className="mobile-header">
            <FaBars className="menu-icon" onClick={toggleMobileMenu} />
          </div>

          {/* Mobile Sidebar */}
          {isMobileMenuOpen && (
            <div className="sidebar mobile-sidebar">
              <button className="close-menu-btn" onClick={closeMobileMenu}>
                <FaTimes className="close-icon" />
              </button>
              <nav>
                <ul>
                  {/* Profile Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleProfile}
                    >
                      <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                      {isprofileDropdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isprofileDropdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/add_profile_details"
                            onClick={closeMobileMenu}
                          >
                            Add
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Employees Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleDropdown}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Employees
                      {isDropdownOpen ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            Attendance
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Unemployed Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleUnemployed}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Unemployed
                      {isUnemployeddown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isUnemployeddown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/new_unemployed"
                            onClick={closeMobileMenu}
                          >
                            New
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Suggestion and Counseling Section for Mobile */}
                  <li>
                    <NavLink
                      to="/socialworkersuggestion"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                      <span>Suggestion and Counseling</span>
                    </NavLink>
                  </li>

                  {/* Logout Section for Mobile */}
                  <li>
                    <NavLink to="/">
                      <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                      Logout
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      ) : user == "Manager" ? (
        <div className="dashboard-content">
          <div className="sidebar">
            <div className="sidebar-profile">
              {image ? (
                <img src={image} className="user-img" />
              ) : (
                <img src="user8.jpeg" alt="Profile" />
              )}
              <p>{username}</p>
              <span>✅ Verified</span>
            </div>
            <nav>
              <ul>
                {/* Profile Section */}
                <li className={`dropdown ${isprofileDropdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleProfile();
                    }}
                    className="dropdown-toggles"
                  >
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isprofileDropdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/profile">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="/add_profile_details">Add</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Employees Section */}
                <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Employees
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isDropdownOpen && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="/viewEmployees">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="">Attendance</NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                {/* Premium Membership */}
                <li
                  className={`dropdown ${
                    isPremiumMembershipManager ? "open" : ""
                  }`}
                >
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      togglePremiumMembershipManager();
                    }}
                  >
                    <MdCardMembership className="icon" /> Premium Membership
                    {isPremiumMembershipManager ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isPremiumMembershipManager && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/premiumMembershipManageComp">
                          Company
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/premiumMembershipManagerEmp">
                          Employee
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Unemployed Section */}
                <li className={`dropdown ${isUnemployeddown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleUnemployed();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Unemployed
                    {isUnemployeddown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isUnemployeddown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/new_unemployed">New</NavLink>
                      </li>
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Suggestion and Counseling Section */}
                <li>
                  <NavLink
                    to="/socialworkersuggestion"
                    className="flex items-center"
                  >
                    <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                    <span className="whitespace-nowrap">
                      Suggestion and Counseling
                    </span>
                  </NavLink>
                </li>

                {/* Logout Section */}
                <li>
                  <a onClick={Logout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Mobile Header */}
          <div className="mobile-header">
            <FaBars className="menu-icon" onClick={toggleMobileMenu} />
          </div>

          {/* Mobile Sidebar */}
          {isMobileMenuOpen && (
            <div className="sidebar mobile-sidebar">
              <button className="close-menu-btn" onClick={closeMobileMenu}>
                <FaTimes className="close-icon" />
              </button>
              <nav>
                <ul>
                  {/* Profile Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleProfile}
                    >
                      <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                      {isprofileDropdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isprofileDropdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/add_profile_details"
                            onClick={closeMobileMenu}
                          >
                            Add
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Employees Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleDropdown}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Employees
                      {isDropdownOpen ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/viewEmployees"
                            onClick={closeMobileMenu}
                          >
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            Attendance
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={togglePremiumMembershipManager}
                    >
                      <MdCardMembership className="icon" />
                      Premium Membership
                      {isPremiumMembershipManager ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isPremiumMembershipManager && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/premiumMembershipManageComp"
                            onClick={togglePremiumMembershipManager}
                          >
                            Company
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/premiumMembershipManagerEmp"
                            onClick={togglePremiumMembershipManager}
                          >
                            Employee
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Unemployed Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleUnemployed}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Unemployed
                      {isUnemployeddown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isUnemployeddown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/new_unemployed"
                            onClick={closeMobileMenu}
                          >
                            New
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Suggestion and Counseling Section for Mobile */}
                  <li>
                    <NavLink
                      to="/socialworkersuggestion"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                      <span>Suggestion and Counseling</span>
                    </NavLink>
                  </li>

                  {/* Logout Section for Mobile */}
                  <li>
                    <NavLink to="/">
                      <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                      Logout
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      ) : user == "Counseller" ? (
        <div className="dashboard-content">
          <div className="sidebar">
            <div className="sidebar-profile">
              {image ? (
                <img src={image} className="user-img" />
              ) : (
                <img src="user8.jpeg" alt="Profile" />
              )}
              <p>{username}</p>
              <span>✅ Verified</span>
            </div>
            <nav>
              <ul>
                {/* Profile Section */}
                <li className={`dropdown ${isprofileDropdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleProfile();
                    }}
                    className="dropdown-toggles"
                  >
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isprofileDropdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/profile">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="/add_profile_details">Add</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Employees Section */}
                <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Employees
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isDropdownOpen && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="">Attendance</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Unemployed Section */}
                <li className={`dropdown ${isUnemployeddown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleUnemployed();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Unemployed
                    {isUnemployeddown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isUnemployeddown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/new_unemployed">New</NavLink>
                      </li>
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Suggestion and Counseling Section */}
                <li>
                  <NavLink
                    to="/counsellersuggestion"
                    className="flex items-center"
                  >
                    <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                    <span className="whitespace-nowrap">
                      Suggestion and Counseling
                    </span>
                  </NavLink>
                </li>

                {/* Logout Section */}
                <li>
                  <a onClick={Logout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Mobile Header */}
          <div className="mobile-header">
            <FaBars className="menu-icon" onClick={toggleMobileMenu} />
          </div>

          {/* Mobile Sidebar */}
          {isMobileMenuOpen && (
            <div className="sidebar mobile-sidebar">
              <button className="close-menu-btn" onClick={closeMobileMenu}>
                <FaTimes className="close-icon" />
              </button>
              <nav>
                <ul>
                  {/* Profile Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleProfile}
                    >
                      <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                      {isprofileDropdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isprofileDropdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/add_profile_details"
                            onClick={closeMobileMenu}
                          >
                            Add
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Employees Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleDropdown}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Employees
                      {isDropdownOpen ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            Attendance
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Unemployed Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleUnemployed}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Unemployed
                      {isUnemployeddown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isUnemployeddown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/new_unemployed"
                            onClick={closeMobileMenu}
                          >
                            New
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Suggestion and Counseling Section for Mobile */}
                  <li>
                    <NavLink
                      to="/counsellersuggestion"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                      <span>Suggestion and Counseling</span>
                    </NavLink>
                  </li>

                  {/* Logout Section for Mobile */}
                  <li>
                    <NavLink to="/" onClick={bothwork}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                      Logout
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      ) : user == "Admin" ? (
        <div className="dashboard-content">
          <div className="sidebar">
            <div className="sidebar-profile">
              {image ? (
                <img src={image} className="user-img" />
              ) : (
                <img src="user8.jpeg" alt="Profile" />
              )}
              <p>{username}</p>
              <span>✅ Verified</span>
            </div>
            <nav>
              <ul>
                {/* Profile Section */}
                <li className={`dropdown ${isprofileDropdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleProfile();
                    }}
                    className="dropdown-toggles"
                  >
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isprofileDropdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/profile">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="/add_profile_details">Add</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Employees Section */}
                <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Employees
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isDropdownOpen && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="/viewEmployees">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="">Attendance</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Unemployed Section */}
                <li className={`dropdown ${isUnemployeddown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleUnemployed();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Unemployed
                    {isUnemployeddown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isUnemployeddown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/new_unemployed">New</NavLink>
                      </li>
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Suggestion and Counseling Section */}
                <li>
                  <NavLink
                    to="/counsellersuggestion"
                    className="flex items-center"
                  >
                    <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                    <span className="whitespace-nowrap">
                      Suggestion and Counseling
                    </span>
                  </NavLink>
                </li>

                {/* Logout Section */}
                <li>
                  <a onClick={Logout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Mobile Header */}
          <div className="mobile-header">
            <FaBars className="menu-icon" onClick={toggleMobileMenu} />
          </div>

          {/* Mobile Sidebar */}
          {isMobileMenuOpen && (
            <div className="sidebar mobile-sidebar">
              <button className="close-menu-btn" onClick={closeMobileMenu}>
                <FaTimes className="close-icon" />
              </button>
              <nav>
                <ul>
                  {/* Profile Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleProfile}
                    >
                      <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                      {isprofileDropdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isprofileDropdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/add_profile_details"
                            onClick={closeMobileMenu}
                          >
                            Add
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Employees Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleDropdown}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Employees
                      {isDropdownOpen ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/viewEmployees"
                            onClick={closeMobileMenu}
                          >
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            Attendance
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Unemployed Section for Mobile */}
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleUnemployed}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Unemployed
                      {isUnemployeddown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isUnemployeddown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/new_unemployed"
                            onClick={closeMobileMenu}
                          >
                            New
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>

                  {/* Suggestion and Counseling Section for Mobile */}
                  <li>
                    <NavLink
                      to="/counsellersuggestion"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                      <span>Suggestion and Counseling</span>
                    </NavLink>
                  </li>

                  {/* Logout Section for Mobile */}
                  <li>
                    <NavLink to="/" onClick={bothwork}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                      Logout
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      ) : (
        <div className="dashboard-content">
          <div className="sidebar">
            <div className="sidebar-profile">
              {image ? (
                <img src={image} className="user-img" />
              ) : (
                <img src="user8.jpeg" alt="Profile" />
              )}
              <p>{username}</p>
              <span>✅ Verified</span>
            </div>
            <nav>
              <ul>
                <li className={`dropdown ${isprofileDropdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleProfile();
                    }}
                    className="dropdown-toggles"
                  >
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isprofileDropdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/profile">View</NavLink>
                      </li>
                      <li>
                        <NavLink to="/add_profile_details">Add</NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Employees
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isDropdownOpen && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="">Attendence</NavLink>
                      </li>
                      <li>
                        <NavLink to="/manager-change-requests">
                          Job/stream change requests
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/blacklist-requests">
                          Blacklist requests
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/further-blacklist-requests">
                          Further Blacklist Requests
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/employee_lending_requests_page">
                          Lending Requests
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/employees_needed_requests_page">
                          Needed Requests
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                <li className={`dropdown ${isUnemployeddown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleUnemployed();
                    }}
                  >
                    <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                    Unemployed
                    {isUnemployeddown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isUnemployeddown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/new_unemployed">New</NavLink>
                      </li>
                      <li>
                        <NavLink to="">All</NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li className={`dropdown ${isProductsdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleproducts();
                    }}
                  >
                    <FontAwesomeIcon icon={faGears} className="icon" /> Products
                    {isProductsdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isProductsdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/new_products_page">New</NavLink>
                      </li>
                      <li>
                        <NavLink to="/all_products">All</NavLink>
                      </li>
                      <li>
                        <NavLink to="/new_ads_requests">Ads Request</NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li className={`dropdown ${isHighlightdown ? "open" : ""}`}>
                  <NavLink
                    to="#"
                    className="dropdown-toggles"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleHighlight();
                    }}
                  >
                    <FontAwesomeIcon icon={faBuilding} className="icon" />{" "}
                    Company
                    {isHighlightdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </NavLink>
                  {isHighlightdown && (
                    <ul className="dropdown-menuse">
                      <li>
                        <NavLink to="/all_companies_page">
                          All Companies
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/company_highlight_request_manager">
                          Company Higlight
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/product_highlight_request_manager">
                          Product Highlight
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <NavLink
                    to="/managersuggestion"
                    className="flex items-center"
                  >
                    <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                    <span className="whitespace-nowrap">
                      Suggestion and Counseling
                    </span>
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/all_jobs_page">
                    <FontAwesomeIcon icon={faFileAlt} className="icon" />
                    All Jobs
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/technical_support_requests">
                    <FontAwesomeIcon icon={faGears} className="icon" />
                    Support Requests
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/target_audience_page_admin">
                    <FontAwesomeIcon icon={faBullseye} className="icon" />
                    Target Audience
                  </NavLink>
                </li>
                <li>
                  <a onClick={Logout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div className="mobile-header">
            <FaBars className="menu-icon" onClick={toggleMobileMenu} />
          </div>

          {isMobileMenuOpen && (
            <div className="sidebar mobile-sidebar">
              <button className="close-menu-btn" onClick={closeMobileMenu}>
                <FaTimes className="close-icon" />
              </button>
              <nav>
                <ul>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleProfile}
                    >
                      <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                      {isprofileDropdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isprofileDropdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="/profile" onClick={closeMobileMenu}>
                            View
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/add_profile_details"
                            onClick={closeMobileMenu}
                          >
                            Add
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleDropdown}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      Employees
                      {isDropdownOpen ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            Attendence
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/manager-change-requests">
                            Job/stream change requests
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/blacklist-requests">
                            Blacklist requests
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/further-blacklist-requests">
                            Further Blacklist Requests
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/employee_lending_requests_page"
                            onClick={closeMobileMenu}
                          >
                            Lending Requests
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/employees_needed_requests_page"
                            onClick={closeMobileMenu}
                          >
                            Needed Requests
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleUnemployed}
                    >
                      <FontAwesomeIcon icon={faUsers} className="icon" />{" "}
                      UnEmployed
                      {isUnemployeddown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isUnemployeddown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/new_unemployed"
                            onClick={closeMobileMenu}
                          >
                            New
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleproducts}
                    >
                      <FontAwesomeIcon icon={faGears} className="icon" />{" "}
                      Products
                      {isProductsdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isProductsdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/new_products_page"
                            onClick={closeMobileMenu}
                          >
                            New
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/all_products" onClick={closeMobileMenu}>
                            All
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/new_ads_requests"
                            onClick={closeMobileMenu}
                          >
                            Ads Request
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <button
                      className="dropdown-toggles"
                      onClick={toggleHighlight}
                    >
                      <FontAwesomeIcon icon={faBuilding} className="icon" />{" "}
                      Company
                      {isHighlightdown ? (
                        <FaChevronUp className="dropdown-icons" />
                      ) : (
                        <FaChevronDown className="dropdown-icons" />
                      )}
                    </button>
                    {isHighlightdown && (
                      <ul className="dropdown-menus">
                        <li>
                          <NavLink
                            to="/all_companies_page"
                            onClick={closeMobileMenu}
                          >
                            All Companies
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/company_highlight_request_manager"
                            onClick={closeMobileMenu}
                          >
                            Company Highlight
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/product_highlight_request_manager"
                            onClick={closeMobileMenu}
                          >
                            Product Higlight
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <NavLink
                      to="/managersuggestion"
                      className="flex items-center"
                    >
                      <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                      <span className="whitespace-nowrap">
                        Suggestion and Counseling
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/all_jobs_page" onClick={closeMobileMenu}>
                      <FontAwesomeIcon icon={faFileAlt} className="icon" /> All
                      Jobs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/technical_support_requests"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faGears} className="icon" />{" "}
                      Support Requests
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/target_audience_page_admin"
                      onClick={closeMobileMenu}
                    >
                      <FontAwesomeIcon icon={faBullseye} className="icon" />{" "}
                      Target Audience
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="" onClick={bothwork}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                      Logout
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          )}
          {/* <div className="content">
          <div className="company-header">
            <img
              src="employer1.png"
              alt="Company Logo"
              className="company-logo"
            />
           <div className="company-details">
              <h2 style={{textTransform:'uppercase'}}>{username}</h2>
            </div>
          </div>
        </div> */}
        </div>
      )}
    </div>
  );
}
export default Navbar;
